module.exports = __webpack_public_path__ + "static/media/icon_calendar.ad84e5de.svg";